import { ProductStockRecord } from './stock.types';

export class StockDelta {
  item: ProductStockRecord;
  delta: number; // positivo: restaurar, negativo: consumir, cero: no hacer nada

  constructor(item: ProductStockRecord, delta: number) {
    this.item = item;
    this.delta = delta;
  }
}
